import { Faq } from '@/lib/interfaces';
import {
  CLIENT_TERMS_AND_CONDITIONS_URL,
  MAILTO_EMAIL,
} from '@/utils/constants';
import Link from 'next/link';

export const faqs: Faq[] = [
  {
    question: 'Do I need to have an OLEA account to purchase items?',
    answer:
      'You must be a registered collector to purchase from OLEA, please join us.',
  },
  {
    question: 'When will my artwork ship?',
    answer:
      'Domestic and international shipping options are available, however some artworks are restricted to certain regions.',
  },
  {
    question: 'Where do you ship?',
    answer: 'Shipping is currently available worldwide.',
  },
  {
    question: 'What is the refund policy?',
    answer: (
      <div>
        All sales are final, there are no refunds or exchanges. If you have
        questions you can find more information in our{' '}
        <Link href={CLIENT_TERMS_AND_CONDITIONS_URL} className="font-medium">
          Terms &amp; Conditions
        </Link>
        , or feel free to send us an email at{' '}
        <Link href={MAILTO_EMAIL} className="font-medium">
          info@olea.art
        </Link>
      </div>
    ),
  },
  {
    question: 'What if my artwork arrives damaged?',
    answer: (
      <div>
        In the unlikely circumstance that your order arrives damaged, please
        contact us immediately at{' '}
        <Link href={MAILTO_EMAIL} className="font-medium">
          info@olea.art
        </Link>
        . Please note that you will be asked to provide sufficient evidence,
        including but not limited to photos, videos, written accounts, etc.
      </div>
    ),
  },
  {
    question: 'Will my artwork have a certificate of authenticity?',
    answer: (
      <div>
        If an artwork has an original certificate of authenticity (not all
        artworks are released with a certificate of authenticity) then it will
        accompany the item. All items are verified before shipment by the OLEA
        team. We do not provide certificates of authenticity. If you have any
        questions please contact us at{' '}
        <Link href={MAILTO_EMAIL} className="font-medium">
          info@olea.art
        </Link>
      </div>
    ),
  },
  {
    question: 'What form of payment do you accept?',
    answer:
      'At checkout you will see available payment options, which include PayPal and ShopPay, to support credit and debit card payments for your purchase. Some items may require payment by wire or bank transfer.',
  },
];
